import Footer from '../../components/Commons/Footer';
import NavBar from '../../components/Commons/NavBar';
import MovieCard from '../../components/Movies/MovieCard';
import { ListContents, Grid, TitleList, WithoutContent, CardWrapper } from './styles';
import EmptyList from '../../assets/icon-empty.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import GridSkeleton from '../../components/Commons/GridSkeleton';
import { getContentTag, getTrailTag } from '../../services/tags';
import { Mobile } from 'utils/responsiveRules';
import MobileNavigatorSpace from 'components/Commons/MobileNavigatorSpace';
import { getMusics } from '../../services/contents'

const NoContent = () => (
	<WithoutContent>
		<div>
			<img src={EmptyList} alt="" />
		</div>
		<p>Nenhum conteúdo a esta categoria no momento. Navegue pelo catálogo para encontrar mais conteúdos.</p>
	</WithoutContent>
);

export default function Shows() {
	const [musics, setMusic] = useState<any>();
	const getData = async () => {
		const content = await getMusics();
	
		setMusic(content);
	};
	useEffect(() => {
		getData();
	}, []);

	return (
		<>
			<NavBar />
			<ListContents>
				<TitleList>Shows, Apresentações e Videoclips</TitleList>
				{!musics && <GridSkeleton />}
				{musics?.length <= 0 && <NoContent />}
				<Grid>
					{musics &&
						musics.map((course: any, key: any) => {
							if (course?.is_library) {
								return (
									<CardWrapper>
										<MovieCard to={`/movie/${course.content_id}`} data={course} key={`course-${key}`} />
									</CardWrapper>
								);
							} else {
								return (
									<CardWrapper>
										<MovieCard to={`/trail/${course.trail_id}`} data={course} key={`course-${key}`} />
									</CardWrapper>
								);
							}
						})}
				</Grid>
			</ListContents>
			<Footer />
			<Mobile>
				<MobileNavigatorSpace />
			</Mobile>
		</>
	);
}
